// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","791":"ee9ce975"}[chunkId] + "-" + {"245":"1263b16588726c7d2145","453":"4392c0b805ea49832da4","791":"2e9b286781a17e185fcb"}[chunkId] + ".js";
};